<template>
  <spr-dialog name="permissions" :show="show" :title="title" @confirm="handleConfirm" @open="handleOpen" @update:show="(flag) => this.$emit('update:show', flag)">
    <p style="margin-left: 50px" v-show="contactName">给联系人：【<span style="color: red">{{contactName}}</span>】分配账户及权限</p>
    <el-form label-position="top" style="margin: 0 50px;">
      <el-form-item class="bold">
        <el-form ref="form" :model="Form" :rules="Rules" class="sub-form" label-suffix="：" :inline="true" label-position="left">
          <el-form-item label="分部" prop="PartnerRegionId">
            <el-select v-model="Form.PartnerRegionId" style="width: 280px; margin-right: 400px">
              <el-option v-for="Company in Companys" :key="Company.Id" :label="Company.Name" :value="Company.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="登录账户" prop="Name">
            <el-input style="width: 280px;" v-model="Form.Name"></el-input>
          </el-form-item>
          <el-form-item label="设置登录密码" prop="Password" style="margin-left: 100px">
            <el-input style="width: 280px;" type="password" v-model="Form.Password"></el-input>
          </el-form-item>
        </el-form>
      </el-form-item>
      <el-form-item class="bold" label="权限选择">
        <el-checkbox-group v-model="Form.Permissions">
          <el-checkbox label="/">首页</el-checkbox>
          <el-checkbox label="/entrust">委托查询</el-checkbox>
          <el-checkbox label="/lease">租赁查询</el-checkbox>
          <el-checkbox label="/inventory">库存查询</el-checkbox>
          <el-checkbox label="/repair">维修查询</el-checkbox>
          <el-checkbox label="/logistics">物流信息查询</el-checkbox>
          <el-checkbox label="/financial">结算查询</el-checkbox>
          <el-checkbox label="/order">订单管理</el-checkbox>
          <el-checkbox label="/profile/info">个人中心</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
  </spr-dialog>
</template>

<script>
import SprDialog from './Dialog'
import SprAddress from '@/components/common/Address'
import o from '@/odata'
export default {
  data() {
    return {
      Form: {
        Name: null,
        Password: null,
        PartnerRegionId: null,
        Permissions: [],
        ContactorId: null,
      },
      Rules: {
        Name: [{ required: true, message: '该字段必填', trigger: 'blur' }],
        Password: [{ required: true, message: '该字段必填', trigger: 'blur' }],
        PartnerRegionId: [{ type: 'number', required: true, message: '该字段必填', trigger: 'blur' }],
      },
      Companys: [],
    }
  },
  props: {
    form: null,
    show: Boolean,
    title: String,
    contactName: String,
    callbackMethod: '',
  },
  methods: {
    handleConfirm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let data = {}
          if (this.callbackMethod === 'update') {
            data = {
              Id: this.Form.Id,
              PartnerRegionId: this.Form.PartnerRegionId,
              Name: this.Form.Name,
              Password: this.Form.Password,
              PermissionJson: JSON.stringify(this.Form.Permissions),
            }
          } else if (this.callbackMethod === 'create') {
            const user = JSON.parse(window.localStorage.getItem('CURRENT_USER'))
            data = {
              PartnerRegionId: this.Form.PartnerRegionId,
              Name: this.Form.Name,
              Password: this.Form.Password,
              PermissionJson: JSON.stringify(this.Form.Permissions),
              ContactorId: this.Form.ContactorId,
              CustomerCode: user.customer.customerCode,
              CreateBy: user.customer.customerCode,
            }
          }
          console.log('data', data)
          this.$emit(this.callbackMethod, data)
        }
      })
    },
    handleOpen() {
      this.getCompanyInfo()
      console.log('this.form', this.form)
      const form = this.form.Id ? Object.assign({}, this.form) : {
        Id: this.form.Id,
        Name: this.form.Name,
        Password: this.form.Password,
        PartnerRegionId: this.form.PartnerRegionId,
        Permissions: [],
        ContactorId: this.form.ExternalId,
      }
      if (form.PermissionJson) {
        form.Permissions = JSON.parse(form.PermissionJson)
      } else {
        form.Permissions = []
      }
      this.$set(this, 'Form', form)
    },
    getCompanyInfo() {
      const user = JSON.parse(window.localStorage.getItem('CURRENT_USER'))
      o('PartnerRegion').filter(`PartnerId eq ${user.customer.customerId}`)
      .get().then(({data}) => {
        this.Companys = data
      })
    },
  },
  components: {
    SprDialog,
    SprAddress,
  },
}
</script>

<style lang="less">
.work-place.address-box {
  display: block;
  width: auto !important;
  .el-col {
    width: auto;
    margin-right: 6px;
    &:nth-child(3),
    &:nth-child(4) {
      margin-right: 0;
    }
  }
  .province,
  .city,
  .county {
    width: 126px;
  }
  .address {
    width: 390px;
    margin-top: 6px;
  }
}

.inner-form {
  // margin-left: 67px;
  .el-form-item {
    margin: 0;
    .el-form-item__content {
      min-width: 100px;
    }
  }
}
</style>
<style lang="less" scoped>
.spr-dialog .el-form .el-checkbox-group .el-checkbox {
  margin-left:0px;
  margin-right:20px;
}
</style>




// WEBPACK FOOTER //
// PermissionsDialog.vue?57773019